import { render, staticRenderFns } from "./ImportJobDetailProvisioningComparison.vue?vue&type=template&id=2f67b33d&"
import script from "./ImportJobDetailProvisioningComparison.vue?vue&type=script&lang=ts&"
export * from "./ImportJobDetailProvisioningComparison.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCheckbox,VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f67b33d')) {
      api.createRecord('2f67b33d', component.options)
    } else {
      api.reload('2f67b33d', component.options)
    }
    module.hot.accept("./ImportJobDetailProvisioningComparison.vue?vue&type=template&id=2f67b33d&", function () {
      api.rerender('2f67b33d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/import/ImportJobDetailProvisioningComparison.vue"
export default component.exports